<script setup lang="ts">
import { resetPassword } from '@/helpers/auth'
import { errToStr } from '@/helpers/tools'
import { formRules as rules } from '@/helpers/validators'
import { ref, type Ref } from 'vue'
import { useI18n } from 'vue-i18n'
import KpTextfield from '@/components/kp-textfield.vue'

const username: Ref<string | null> = ref(null)
const success: Ref<string | null> = ref(null)
const error: Ref<string | null> = ref(null)
const valid = ref(false)
const loading = ref(false)

const { t } = useI18n()

async function resetPW() {
    try {
        await resetPassword(username.value || '')
        success.value = t('reset_confirm', { username: username.value })
    } catch (e) {
        error.value = errToStr(e)
    }
}
</script>

<template>
    <div>
        <v-container>
            <v-row justify="center">
                <v-col cols="12" sm="9">
                    <v-form v-model="valid" autocomplete="on" @submit.prevent="resetPW">
                        <v-card
                            class="trans-bg"
                            max-width="600px"
                            style="margin: auto; margin-top: 10rem; padding-left: 1rem"
                        >
                            <v-card-title>{{ $t('reset_pw') }}</v-card-title>
                            <v-card-text>
                                <KpTextfield
                                    v-model="username"
                                    :label="$t('email')"
                                    :placeholder="$t('zb') + ' name@domain.com'"
                                    icon-type="email"
                                    autocomplete="on"
                                    :autofocus="true"
                                    :disabled="loading"
                                    :rules="[rules.required, rules.email]"
                                />
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer />
                                <v-btn to="/" :disabled="loading">{{ $t('cancel') }}</v-btn>
                                <v-btn
                                    variant="flat"
                                    color="primary"
                                    type="submit"
                                    :loading="loading"
                                    :disabled="!valid || loading || !!success"
                                    @click.prevent="resetPW"
                                >
                                    {{ $t('reset') }}
                                </v-btn>
                            </v-card-actions>

                            <v-card-text v-if="success">
                                <v-alert type="success">{{ success }}</v-alert>
                            </v-card-text>
                            <v-card-text v-if="error">
                                <v-alert type="error">{{ error }}</v-alert>
                            </v-card-text>
                        </v-card>
                    </v-form>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
